<template>
  <div class="pay-h5-wrapper">
    <div class="student-card">学生证申领登记</div>
    <img src="@/assets/payH5/background.png" class="book-img">
    <div class="info-write">
      <div class="form-wrapper">
        <el-form ref="form" :model="form" label-width="90px">
          <el-form-item label="学校名称" prop="schoolName">
            <span class="school-name">{{ form.schoolName }}</span>
          </el-form-item>
          <el-form-item label="班级名称" prop="className" class="form-back">
            <el-select v-model="form.className" placeholder="请选择孩子所在班级" class="select-box">
              <el-option v-for="(item,index) in classList" :value="item.classId" :label="item.className"
                         :key="item.classId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" prop="studentName" class="form-back">
            <el-input v-model="form.studentName" maxlength="16"
                      placeholder="请输入孩子姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone" class="form-back">
            <el-input v-model="form.phone"
                      type="number" pattern="[0-9]*"
                      oninput="if(value.length>11)value=value.slice(0,11)"
                      placeholder="请输入家长的手机号码"></el-input>
          </el-form-item>
        </el-form>
        <div class="important-info">*孩子姓名和家长手机号码是开通学生证的重要信息，请准确填写。</div>
      </div>
      <div class="zhifubao-wrapper" v-if="isZhiFuBaoPay" @click="changePay(1)">
        <div class="pay-select-left">
          <img src="@/assets/payH5/zhifubaoicon.png">
          <span>支付宝支付</span>
        </div>
        <img v-if="isZhiFuBao" src="@/assets/payH5/select.png">
        <img v-else src="@/assets/payH5/noselect.png">
      </div>
      <div class="huabei-wrapper" v-if="isZhiFuBaoPay" @click="changePay(2)">
        <img src="@/assets/payH5/huabeiicon.png">
        <div class="huabei-text">
          <div>花呗分期（无折扣）</div>
          <div class="box">
            <div>分12期（免手续费）</div>
            <!--            currentPackage.installmentMoney-->
            <div>￥{{ fenzimoney }}/期</div>
          </div>
        </div>
        <img v-if="!isZhiFuBao" src="@/assets/payH5/select.png">
        <img v-else src="@/assets/payH5/noselect.png">
      </div>
      <div @click="canEdit?payButton():''" :class="[canEdit?'pay-button':'no-pay-button']">
      <span>
        ￥{{ currentPackage.chargeMoney }}缴费申领
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import {isMobile} from "@/utils/vaildate";
import {Dialog, Toast} from "vant";
import {getAccessToken, getBaseInfoBySchoolId, listChargeConfigBySchoolId, payArouse, payCreate} from "@/api/payH5";

export default {
  name: "pay",
  data() {
    return {
      form: {
        schoolName: "",
        className: "",
        studentName: "",
        phone: "",
      },
      classList: [],
      schoolId: "",
      //支付宝or花呗
      isZhiFuBao: true,
      // 微信or支付宝
      isZhiFuBaoPay: false,
      //全部套餐
      package: [],
      //当前套餐（分期/不分期），默认两年套餐
      currentPackage: {
        installmentMoney: 0,
        chargeMoney: 0
      },
      openId: "",
      fenzimoney: 0
    }
  },
  computed: {
    canEdit() {
      // 3个输入框都有值的时候可以点击按钮
      return this.form.className && this.form.studentName && this.form.phone;
    }
  },
  mounted() {
    this.getisZhiFuBaoPay();
    this.getSchoolId();
    this.getCode();
  },
  methods: {
    getisZhiFuBaoPay() {
      //微信过来的
      let result = this.getQueryString('isZhiFuBaoPay');
      if (result === false) {
        this.isZhiFuBaoPay = result
      }
      // 没有值传过来，说明是路由过来的，支付宝
      if (result === '' || result === null) {
        this.isZhiFuBaoPay = true
      }
    },
    getCode() {
      let code = this.getQueryString('code');
      if (code) {
        getAccessToken({
          js_code: code
        }).then(res => {
          this.openId = res.content.openid;
        })
      }
    },
    changePay(e) {
      if (e === 1) {
        this.isZhiFuBao = true;
        this.currentPackage = this.package.find(p => p.chargeType === 2);
      }
      if (e === 2) {
        this.isZhiFuBao = false;
        this.currentPackage = this.package.find(p => p.chargeType === 3);
      }
    },
    getSchoolId() {
      let schoolId = this.getQueryString('schoolId')
      this.schoolId = schoolId;
      getBaseInfoBySchoolId({schoolId: schoolId}).then(res => {
        if (res.success === false) {
          Dialog.alert({
            title: '提示',
            message: res.errorMsg,
          }).then(() => {
            // on close
          });
          return;
        }
        this.form.schoolName = res.content.schoolName;
        this.classList = res.content.className.map(p => {
          return {
            classId: p,
            className: p
          }
        })
      })
      listChargeConfigBySchoolId({schoolId: schoolId}).then(res => {
        this.package = res.content;
        //  确认套餐内容，目前是两年,默认是不分期（微信、支付宝同）
        this.currentPackage = res.content.find(p => p.chargeType === 2);
        this.fenzimoney = res.content.find(p => p.chargeType === 3).installmentMoney;
      })
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    payButton() {
      let that = this;
      if (!isMobile(that.form.phone)) {
        Toast('手机号码格式有误！')
        return;
      }
      payCreate({
        goodsId: that.currentPackage.chargeConfigId,
        totalAmount: that.currentPackage.chargeMoney,
        realFee: that.currentPackage.chargeMoney,
        payFrom: 'H5',
        phone: that.form.phone,
        studentName: that.form.studentName,
        schoolName: that.form.schoolName,
        schoolId: that.schoolId,
        className: that.form.className,
      }).then(res3 => {
        //创建订单后，唤起支付
        let payType;
        if (that.isZhiFuBaoPay) {
          payType = "ALIPAY_WAP"
          payArouse({
            orderId: res3.content.orderId,
            payType: payType
          }).then(res2 => {
            const div = document.createElement('formdiv');
            div.innerHTML = res2.content.orderInfo;
            document.body.appendChild(div);
            document.forms[1].acceptCharset = 'UTF-8';
            document.forms[1].submit();
            div.remove();
          })
        } else {
          payType = "WX_PUB"
          payArouse({
            openId: that.openId,
            orderId: res3.content.orderId,
            payType: payType
          }).then(res1 => {
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
              appId: res1.content.appId,
              nonceStr: res1.content.nonceStr,
              package: res1.content.package,
              signType: res1.content.signType,
              timeStamp: res1.content.timeStamp,
              paySign: res1.content.paySign
            }, result => {
              // 根据get_brand_wcpay_request的值判断支付状态
              if (result.err_msg === "get_brand_wcpay_request:ok") {
                that.$router.push({
                  name: "paySuccess",
                  query: {
                    orderId: res3.content.orderId
                  }
                })
                // ok：支付成功
                // 支付成功要做的事儿，比如跳转支付完成后的页面等
              } else if (result.err_msg === "get_brand_wcpay_request:cancel") {
                // cancel：用户取消支付
                Toast('取消支付！')
                // 取消支付要做的事儿，比如进入重新支付步骤等
              } else if (result.err_msg === "get_brand_wcpay_request:fail") {
                // fail：支付失败
                Toast('支付失败！')
                // 支付失败要做的事儿，比如进入支付失败步骤等
              }
              // 注：使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok,但并不保证它绝对可靠。
            })
          })
        }
      })
      // this.$router.push("/payH5/paySuccess")
    }
  }
}
</script>
<style lang="scss">
.pay-h5-wrapper .el-form-item--medium .el-form-item__content,
.pay-h5-wrapper .el-form-item--medium .el-form-item__label {
  line-height: 50px;
}

.pay-h5-wrapper .el-form-item {
  margin-bottom: 10px;
}

.pay-h5-wrapper .el-input__inner {
  border: none;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
}

.pay-h5-wrapper .el-form-item__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  text-align: justify;
  text-align-last: justify;
  padding-left: 10px;
}

.pay-h5-wrapper .el-input.is-disabled .el-input__inner {
  background-color: #EAEAEA;
  color: #222222;
}

.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
<style scoped lang="scss">
.pay-h5-wrapper {
  width: 100%;
  height: 100%;
  background-color: #DEFEF5;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow-y: auto;

  .student-card {
    position: absolute;
    font-size: 21px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2AD0B5;
    line-height: 24px;
    top: 52px;
  }

  .book-img {
    width: 100%;
  }

  .info-write {
    width: calc(100% - 20px);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 195px;

    .form-wrapper {
      height: 340px;
      width: 100%;
      background: url("../../assets/payH5/info.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 20px 15px 0px 15px;

      .school-name {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }

      .form-back {
        background-color: #FFFFFF;
        border-radius: 10px;

        .select-box {
          width: 100%;
        }
      }

      .important-info {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF6A5C;
        line-height: 20px;
      }
    }

    .zhifubao-wrapper {
      width: 100%;
      height: 70px;
      background: url("../../assets/payH5/zhifubao.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      padding: 0 30px;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
      }

      .pay-select-left {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;

        span {
          margin-left: 6px;
        }
      }
    }

    .huabei-wrapper {
      height: 119px;
      width: 100%;
      background: url("../../assets/payH5/huabei.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-top: 10px;
      display: flex;
      padding: 21px 30px;

      .huabei-text {
        margin-left: 6px;
        flex: 1;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;

        .box {
          width: 135px;
          height: 50px;
          border-radius: 10px;
          border: 1px solid #666666;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-top: 10px;

          div:nth-child(1) {
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          div:nth-child(2) {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .no-pay-button {
      width: 100%;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: #D5D5D5;
      border-radius: 27px;
      margin: 10px 0px;

      span {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    .pay-button {
      width: 100%;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: #2AD0B5;
      box-shadow: 0px 2px 4px 0px rgba(0, 152, 127, 0.3);
      border-radius: 27px;
      margin: 10px 0px;

      span {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-shadow: 0px 2px 4px rgba(0, 152, 127, 0.3);
      }
    }
  }
}
</style>